import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import AcceptInvite from './components/auth/AcceptInvite'
import ForgotPassword from './components/auth/ForgotPassword'
import Login from './components/auth/Login'
import Register from './components/auth/register.js/Register'
import ResetPassword from './components/auth/ResetPassword'
import Dashboard from './components/Dashboard'
import PostHogPageviewTracker from './components/utils/PostHogPageViewTracker'
import axios from 'axios'
import CreateOrganization from './components/auth/CreateOrganization'
import FrontRouteGuard from './components/guards/FrontRouteGuard'

const Main = () => {
  //   const deleteUSEr= async(user_id) =>  {
  //    let deleteUser =await axios
  //    .post(process.env.REACT_APP_BACKEND_URL + "delete-user-by-id", {
  //      userId : user_id,
  //   })
  //  }


   
  //  localStorage.clear()
  //  useEffect(()=> {
  //   deleteUSEr('c5df1e6e49eaeaea7a44ec3e5d9ee108948eced204dfbd28b3195f7be1ae4b45')
  //   deleteUSEr('e9e30c72a752654d4e3b47e00669d3c2473609726e1c8055885f4209ac36d4b2')
  //  })
  return (   
   <>      
    <BrowserRouter>
      <PostHogPageviewTracker/>
      <FrontRouteGuard>
        <Routes>
          <Route path="/dashboard/*" element={<Dashboard/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/accept-invite/:token" element={<AcceptInvite/>} />
          <Route path="/create-organization/" element={<CreateOrganization/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/reset-password/:data" element={<ResetPassword/>} />
          <Route path="/register" element={<Register/>} />
          <Route path="/" element={<Login/>} />
        </Routes>
      </FrontRouteGuard>
    </BrowserRouter>
   </>
  )
}

export default Main